import { Injectable } from '@angular/core';
import { Router, NavigationExtras } from '@angular/router';

@Injectable({ providedIn: 'root' })
export class NavigationService {
  constructor(private readonly router: Router) {}

  /**
   * Navigate using path segments or a string, with optional query parameters and extras.
   */
  goTo(
      path: string | any[],
      queryParams?: Record<string, any>,
      extras: NavigationExtras = {}
  ): void {
    const navigationExtras: NavigationExtras = {
      queryParams,
      ...extras,
    };

    this.router
        .navigate(typeof path === 'string' ? [path] : path, navigationExtras)
        .catch((err) => {
          console.error('Navigation error:', err);
          // Optionally redirect or notify here
        });
  }

  /**
   * Navigate to a raw URL using navigateByUrl.
   */
  navigateByUrl(url: string): void {
    this.router.navigateByUrl(url).catch((err) => {
      console.error('Navigation by URL error:', err);
    });
  }


  /**
   * Navigate one step back in browser history.
   */
  back(): void {
    globalThis.history.back();
  }
}



